"user strict";

angular.module("app").directive("okinaCustomText", ["$sce", function ($sce) {
	return {
		restrict: "E",
		scope: {
			customs: "=",
			key: "="
		},
		template: "<div ng-bind-html=\"valueToBind\"></div>",
		link: function (scope) {
			scope.valueToBind = $sce.trustAsHtml(scope.customs.filter(function (element) {
				return element.key === scope.key;
			})[0].value);

		}
	};
}])
;